<template>
  <div class="lms-pdf" ref="pdfBox" @webkitfullscreenchange="fullscreenchange" @mouseleave="onMouseleave">
    <div class="video-err" v-if="videoFail && !loading"><span>{{videoErrorMe}}</span></div>
    <div class="video-loading" v-loading="loading"></div>
    <div class="lms-pdf-con" ref="conBox" :style="{cursor: movementStatus ? 'move' : 'auto'}">
      <pdf ref="pdf" :src="videoApi" :page="pageNum" v-if="videoApi" @num-pages="pageTotalNum=$event" @progress="loadedRatio = $event" @error="onError" @loaded="loaded" @mousedown.native="pdfMousedown" @mousemove.native="pdfMousemove" @mouseup.native="pdfMouseup">
      </pdf>
    </div>
    <div class="lms-pdf-screen" v-show="!(videoFail && !loading)">
      <div class="lms-pdf-screen-page">
        <i @click.stop="prePage" class="el-icon-arrow-left p-pointer"></i>
        <div>{{pageNum}}/{{pageTotalNum}}</div>
        <i @click.stop="nextPage" class="el-icon-arrow-right p-pointer"></i>
      </div>
      <div class="lms-pdf-screen-zoom">
        <ul>
          <li @click="zommChange('-')"><img :src="require('@m/assets/images/icon/sub.png')"></li>
          <li @click="zommChange('+')"><img :src="require('@m/assets/images/icon/add.png')"></li>
        </ul>
        <div class="proportion">{{zoom}}%</div>
      </div>
      <div class="p-pointer" @click="screenClick">
        <svg v-if="!fullscreen" class="icon" aria-hidden="true">
          <use xlink:href="#iconquanpingbofang"></use>
        </svg>
        <img v-else :src="require('@p/assets/images/icon/suofang.png')">
      </div>
    </div>
    <div class="lms-pdf-progress" :style="{width:(loadedRatio*100)+'%'}"></div>
  </div>
</template>
<script>
import pdf from "@/components/pdf"
import { runPrefixMethod } from '@p/utils/method'
export default {
  data () {
    return {
      fullscreen: false,
      pageTotalNum: 1,                         //总
      pageNum: 1,
      loadedRatio: 0,                          //进度
      loading: true,
      videoFail: false,
      videoErrorMe: '',
      zoom: 100,                              //缩放比
      offsetX: 0,
      offsetY: 0,
      movementStatus: false,
    }
  },
  props: {
    videoApi: {
      type: String,
    },
    resourceError: {
      type: [String, Boolean],
    },
  },
  components: {
    pdf
  },
  watch: {
    videoApi: function (v) {
      this.loading = true
      this.resourceStatus()
    },
  },
  mounted () {
    this.resourceStatus()
  },
  methods: {
    resourceStatus () {
      if (this.resourceError) {
        this.loading = false
        this.videoFail = true
        this.videoErrorMe = '此課堂在外部網絡下無法學習，請連接內部網絡。'
      } else {
        this.videoErrorMe = ''
      }
    },
    prePage () {
      let p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p;
    },
    nextPage () {
      let p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p;
    },
    loaded () { // 已加载
      this.videoFail = false
      this.videoErrorMe = ''
      setTimeout(() => {
        this.loading = false
        this.$emit('loaded')
      }, 1000)
    },
    // 全屏
    screenClick () {
      if (!this.fullscreen) {
        runPrefixMethod(this.$refs.pdfBox, 'RequestFullScreen')
      } else {
        runPrefixMethod(document, 'CancelFullScreen')
      }
    },
    fullscreenchange () {
      this.setPdfStyle(this.zoom)
      this.fullscreen = !this.fullscreen;
    },
    onError () {
      this.videoFail = true;
      this.loading = false
      if (!this.resourceError) {
        this.videoErrorMe = 'PDF資源獲取失敗，請稍後再試！'
      }
    },
    // pdf缩放
    zommChange (calculate) {
      const zoom = eval(`${this.zoom}${calculate}10`)
      if (zoom >= 50 && zoom <= 300) {
        this.zoom = zoom
        this.setPdfStyle(zoom)
      }
    },
    setPdfStyle (zoom) {
      const conBoxWidth = this.$refs.conBox.offsetWidth;
      const pdfWidth = this.$refs.pdf.$el.offsetWidth;
      const centered = (conBoxWidth - conBoxWidth * (zoom / 100)) / 2;
      this.$refs.pdf.$el.style = `width:${zoom}%;position: relative; display: block;margin-left: ${zoom <= 100 ? centered + 'px' : '0'}`
    },
    pdfMousedown (e) {
      this.movementStatus = true
      this.offsetX = e.offsetX;
      this.offsetY = e.offsetY;
    },
    pdfMousemove (e) {
      e.preventDefault();
      if (this.movementStatus) {
        const conBox = this.$refs.conBox;
        const ofX = this.offsetX - e.offsetX;
        const ofY = this.offsetY - e.offsetY;
        const scrollTop = this.$refs.conBox.scrollTop;
        const scrollLeft = this.$refs.conBox.scrollLeft;
        this.$refs.conBox.scrollLeft = ofX + scrollLeft;
        this.$refs.conBox.scrollTop = ofY + scrollTop;
      }
    },
    pdfMouseup () {
      this.movementStatus = false;
    },
    onMouseleave () {
      this.movementStatus = false;
    }
  }
}
</script>

<style lang="less">
.video-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  .el-loading-mask {
    background-color: rgb(0, 0, 0);
    z-index: 1000;
  }
}
</style>
<style lang="less" scoped>
.bu() {
  width: 100%;
  height: 100%;
}
.lms-pdf {
  .bu();
  .video-err {
    color: #d0bd2d;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  background: #000000;
  overflow: hidden;
  padding: 2px;
  box-sizing: border-box;
  position: relative;
  &-con {
    overflow-y: auto;
    width: 100%;
    height: 100%;
    > span {
      width: 100%;
    }
  }
  &-screen {
    position: absolute;
    width: 100%;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    box-sizing: border-box;
    z-index: 10;
    svg {
      color: #eaeaf3;
      font-size: 18px;
    }
    &-page {
      display: flex;
      align-items: center;
      color: #ffffff;
      > div {
        padding: 0 20px;
      }
    }
    &-zoom {
      position: absolute;
      right: 92px;
      display: flex;
      justify-content: center;
      align-content: center;
      color: #ffffff;
      ul {
        display: flex;
        justify-content: center;
        align-content: center;
        li {
          cursor: pointer;
          text-align: center;
          line-height: 18px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin-right: 16px;
          img {
            width: 100%;
          }
        }
      }
      .proportion {
        width: 40px;
        color: #e6e2e2;
      }
    }
  }
  &-progress {
    position: absolute;
    transition: width 1s ease;
    height: 37px;
    background: #000000;
    opacity: 0.2;
    bottom: 0;
    left: 0;
  }
}
</style>